import { render, staticRenderFns } from "./ExpansaoTexto.vue?vue&type=template&id=1cbf2426&scoped=true"
import script from "./ExpansaoTexto.vue?vue&type=script&lang=js"
export * from "./ExpansaoTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf2426",
  null
  
)

export default component.exports